import { render } from "./AllApprovalPendingCases.vue?vue&type=template&id=3aac795d"
import script from "./AllApprovalPendingCases.vue?vue&type=script&lang=js"
export * from "./AllApprovalPendingCases.vue?vue&type=script&lang=js"

import "./AllApprovalPendingCases.vue?vue&type=style&index=0&id=3aac795d&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/AllApprovalPendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3aac795d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3aac795d', __exports__)) {
    console.log('reload')
    api.reload('3aac795d', __exports__)
  }
  
  module.hot.accept("./AllApprovalPendingCases.vue?vue&type=template&id=3aac795d", () => {
    console.log('re-render')
    api.rerender('3aac795d', render)
  })

}


export default __exports__